import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EntityDisplay } from '../../mapping/entity-display.model';
import { DraftTableComponent } from '../draft-table/draft-table.component';

/** Draws what the mapping engine made of one entity's data: its tabs, each a labelled read-only table. */
@Component({
    standalone: true,
    selector: 'p-ai-chat-generic-entity-renderer',
    imports: [DraftTableComponent],
    templateUrl: './generic-entity-renderer.component.html',
    styleUrl: './generic-entity-renderer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericEntityRendererComponent {
    public readonly display = input.required<EntityDisplay>();
}
